// import React, { useState, useEffect } from "react";
// import TextField from "@mui/material/TextField";
// import Autocomplete from "@mui/material/Autocomplete";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import Button from "@mui/material/Button";
// import Backdrop from "@mui/material/Backdrop";
// import CircularProgress from "@mui/material/CircularProgress";
// import CloseIcon from "@mui/icons-material/Close";
// import dayjs from "dayjs";
// import useHttp from "../../Hooks/use-http";
// import {
//   Box,
//   Chip,
//   FormControl,
//   InputLabel,
//   MenuItem,
//   Select,
// } from "@mui/material";
// import * as XLSX from "xlsx";
// import { FormatDateTime } from "../CommonComponent/DateFormat";

// const FuelExportModal = ({ setIsExportButtonClicked }) => {
//   const [vehicles, setVehicles] = useState([]);
//   const [selectedVehicles, setSelectedVehicles] = useState([]);
//   const [fuelPumps, setFuelPumps] = useState([
//     "jio",
//     "adani",
//     "hp",
//     "iocl",
//     "bpcl",
//     "others",
//   ]);
//   const [selectedFuelPumps, setSelectedFuelPumps] = useState([]);
//   const [fuelTypes, setFuelTypes] = useState(["petrol", "diesel", "cng"]);
//   const [selectedFuelTypes, setSelectedFuelTypes] = useState([]);
//   const [startDateValue, setStartDateValue] = useState(dayjs(new Date()));
//   const [endDateValue, setEndDateValue] = useState(dayjs(new Date()));
//   const [isLoading, setIsLoading] = useState(false);
//   const { sendRequest } = useHttp();

//   // Fetch vehicles data
//   useEffect(() => {
//     const fetchVehicles = async () => {
//       setIsLoading(true);
//       try {
//         sendRequest(
//           {
//             url: "/vehicles",
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//             },
//             body: {
//               emailID: localStorage.getItem("user"),
//             },
//           },
//           (data) => {
//             setVehicles(data?.vehicles);
//             setIsLoading(false);
//           }
//         );
//       } catch (error) {
//         console.error("Error fetching vehicles:", error);
//         setIsLoading(false);
//       }
//     };

//     fetchVehicles();
//   }, [sendRequest]);

//   const exportToExcel = (data) => {
//     // Create a new workbook
//     const wb = XLSX.utils.book_new();

//     // 1. Create Summary Sheet
//     const summaryData = [
//       ["Fuel Consumption Report", "", "", "", "", ""],
//       ["", "", "", "", "", ""],
//       [
//         "Period:",
//         `${data.Filters.startDate} to ${data.Filters.endDate}`,
//         "",
//         "",
//         "",
//         "",
//       ],
//       ["Total Vehicles:", data.VehicleSummaries.length, "", "", "", ""],
//       //   ["Total Kilometers:", data.OverallSummary.TotalKm, "", "", "", ""],
//       ["Total Fuel (Ltr/kg):", data.OverallSummary.TotalFuel, "", "", "", ""],
//       [
//         "Total Bill Amount (₹):",
//         data.OverallSummary.TotalBillAmount,
//         "",
//         "",
//         "",
//         "",
//       ],
//       ["", "", "", "", "", ""],
//       ["Detailed Fuel Records", "", "", "", "", ""],
//       ["", "", "", "", "", ""],
//     ];

//     // 2. Create headers for detailed records
//     const headers = [
//       "No.",
//       "Date",
//       "Vehicle Number",
//       "Driver",
//       "Odometer (Km)",
//       "Fuel Pump",
//       "Fuel Type",
//       "Fuel (Ltr/kg)",
//       "Bill Amount (₹)",
//       "Approved By",
//     ];
//     summaryData.push(headers);

//     // 3. Add all fuel records
//     let recordCount = 1;
//     data.VehicleSummaries.forEach((vehicle) => {
//       vehicle.records.forEach((record) => {
//         summaryData.push([
//           recordCount++,
//           // new Date(record.Date).toLocaleDateString(),
//           formatDateToDDMMYYYY(record.Date),
//           vehicle.regNumber,
//           record.DriverName || "N/A",
//           record.Odometer,
//           record.FuelPump,
//           record.FuelType,
//           record.Fuel,
//           record.BillAmount,
//           record.ApprovedBy,
//         ]);
//       });
//     });

//     // Create worksheet
//     const ws = XLSX.utils.aoa_to_sheet(summaryData);

//     // Merge title cells
//     ws["!merges"] = [
//       { s: { r: 0, c: 0 }, e: { r: 0, c: 5 } }, // Title
//       { s: { r: 8, c: 0 }, e: { r: 8, c: 5 } }, // Subtitle
//     ];

//     // Set column widths
//     ws["!cols"] = [
//       { wch: 8 }, // No.
//       { wch: 15 }, // Date
//       { wch: 18 }, // Vehicle Number
//       { wch: 12 }, // Fuel Type
//       { wch: 12 }, // Fuel Pump
//       { wch: 14 }, // Fuel
//       { wch: 14 }, // Odometer
//       { wch: 14 }, // Bill Amount
//       { wch: 20 }, // Approved By
//     ];

//     // Add worksheet to workbook
//     XLSX.utils.book_append_sheet(wb, ws, "Fuel Report");

//     // Generate filename with timestamp
//     const fileName = `Fuel_Report_${dayjs().format("YYYY-MM-DD")}.xlsx`;

//     // Trigger download
//     XLSX.writeFile(wb, fileName);
//   };

//   // Add this helper function outside your component
//   function formatDateToDDMMYYYY(dateString) {
//     if (!dateString) return "";

//     // Extract the date part only (YYYY-MM-DD) before the 'T'
//     const datePart = dateString.split("T")[0];
//     const [year, month, day] = datePart.split("-");

//     return `${day}-${month}-${year}`;
//   }

//   const handleGenerateReport = async () => {
//     setIsLoading(true);

//     try {
//       // Prepare data for API request
//       const requestData = {
//         vehicles: selectedVehicles,
//         // vehicles: selectedVehicles.map((vehicle) => vehicle.regNumber),
//         fuelTypes: selectedFuelTypes,
//         fuelPumps: selectedFuelPumps,
//         startDate: startDateValue.format("YYYY-MM-DD"),
//         endDate: endDateValue.format("YYYY-MM-DD"),
//       };

//       // Make API call
//       const response = await sendRequest({
//         url: "/fuelReportExcel",
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: {
//           emailID: localStorage.getItem("user"),
//           data: requestData,
//         },
//       });

//       if (response && response.VehicleSummaries) {
//         exportToExcel(response);
//       } else {
//         console.error("No valid data received from API");
//         // Show error to user
//       }
//     } catch (error) {
//       console.error("Error generating report:", error);
//       // Show error to user
//     } finally {
//       setIsLoading(false);
//     }
//   };
//   return (
//     <div
//       className="generatePdf-container"
//       style={{
//         zIndex: "999",
//         maxWidth: window.innerWidth <= 468 ? "380px" : "",
//       }}
//     >
//       <header>
//         <span>Fuel Export Report</span>
//         <CloseIcon
//           style={{ cursor: "pointer" }}
//           onClick={() => setIsExportButtonClicked(false)}
//         />
//       </header>
//       <div className="generatePdf-subContainer">
//         <main>
//           <Backdrop
//             sx={{
//               color: "rgba(34, 137, 203, 255)",
//               backgroundColor: "transparent",
//               zIndex: (theme) => theme.zIndex.drawer + 1,
//             }}
//             open={isLoading}
//           >
//             <CircularProgress color="inherit" />
//           </Backdrop>

//           {/* Vehicle Selection (Multiple) */}
//           <Autocomplete
//             multiple
//             id="vehicle-selection"
//             options={vehicles}
//             getOptionLabel={(vehicle) =>
//               `${vehicle.regNumber} - ${vehicle.maker} ${vehicle.model}`
//             }
//             value={selectedVehicles}
//             onChange={(event, newValue) => {
//               setSelectedVehicles(newValue);
//             }}
//             renderInput={(params) => (
//               <TextField
//                 {...params}
//                 variant="standard"
//                 label="Select Vehicles*"
//                 placeholder="Search Vehicles"
//               />
//             )}
//           />

//           <FormControl fullWidth variant="standard" sx={{ mt: 2 }}>
//             <InputLabel id="fuel-pump-label">Fuel Pump</InputLabel>
//             <Select
//               labelId="fuel-pump-label"
//               id="fuel-pump-select"
//               multiple
//               value={selectedFuelPumps}
//               onChange={(e) => setSelectedFuelPumps(e.target.value)}
//               renderValue={(selected) => (
//                 <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
//                   {selected.map((value) => (
//                     <Chip key={value} label={value} />
//                   ))}
//                 </Box>
//               )}
//             >
//               {fuelPumps.map((pump) => (
//                 <MenuItem key={pump} value={pump}>
//                   {pump}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           <FormControl fullWidth variant="standard" sx={{ mt: 2 }}>
//             <InputLabel id="fuel-type-label">Fuel Type</InputLabel>
//             <Select
//               labelId="fuel-type-label"
//               multiple
//               id="fuel-type-select"
//               value={selectedFuelTypes}
//               onChange={(e) => setSelectedFuelTypes(e.target.value)}
//               renderValue={(selected) => (
//                 <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
//                   {selected.map((value) => (
//                     <Chip key={value} label={value} />
//                   ))}
//                 </Box>
//               )}
//             >
//               {fuelTypes.map((type) => (
//                 <MenuItem key={type} value={type}>
//                   {type}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
//               <DatePicker
//                 label="Start Date*"
//                 value={startDateValue}
//                 slotProps={{
//                   textField: {
//                     variant: "standard",
//                     readOnly: true,
//                     inputProps: { sx: { padding: "2px", fontSize: "14px" } },
//                   },
//                 }}
//                 onChange={(newValue) => {
//                   setStartDateValue(newValue);
//                 }}
//               />
//               <DatePicker
//                 label="End Date*"
//                 value={endDateValue}
//                 slotProps={{
//                   textField: {
//                     variant: "standard",
//                     readOnly: true,
//                     inputProps: { sx: { padding: "2px", fontSize: "14px" } },
//                   },
//                 }}
//                 onChange={(newValue) => {
//                   setEndDateValue(newValue);
//                 }}
//               />
//             </div>
//           </LocalizationProvider>
//         </main>
//         <footer>
//           <Button
//             variant="contained"
//             color="success"
//             onClick={handleGenerateReport}
//             disabled={isLoading}
//             sx={{ mt: 2 }}
//           >
//             {isLoading ? "Generating..." : "Generate Report"}
//           </Button>
//         </footer>
//       </div>
//     </div>
//   );
// };

// export default FuelExportModal;

import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Button from "@mui/material/Button";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import useHttp from "../../Hooks/use-http";
import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import * as XLSX from "xlsx";
import { FormatDateTime } from "../CommonComponent/DateFormat";

const FuelExportModal = ({ setIsExportButtonClicked }) => {
  const [vehicles, setVehicles] = useState([]);
  const [selectedVehicles, setSelectedVehicles] = useState([]);
  const [fuelPumps, setFuelPumps] = useState([
    "jio",
    "adani",
    "hp",
    "iocl",
    "bpcl",
    "other",
  ]);
  const [selectedFuelPumps, setSelectedFuelPumps] = useState([]);
  const [fuelTypes, setFuelTypes] = useState(["petrol", "diesel", "cng"]);
  const [selectedFuelTypes, setSelectedFuelTypes] = useState([]);
  const [paymentTypes] = useState(["UPI", "OTP"]);
  const [selectedPaymentTypes, setSelectedPaymentTypes] = useState([]);
  const [startDateValue, setStartDateValue] = useState(dayjs(new Date()));
  const [endDateValue, setEndDateValue] = useState(dayjs(new Date()));
  const [isLoading, setIsLoading] = useState(false);
  const { sendRequest } = useHttp();

  // Fetch vehicles data
  useEffect(() => {
    const fetchVehicles = async () => {
      setIsLoading(true);
      try {
        sendRequest(
          {
            url: "/vehicles",
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: {
              emailID: localStorage.getItem("user"),
            },
          },
          (data) => {
            setVehicles(data?.vehicles);
            setIsLoading(false);
          }
        );
      } catch (error) {
        console.error("Error fetching vehicles:", error);
        setIsLoading(false);
      }
    };

    fetchVehicles();
  }, [sendRequest]);

  const exportToExcel = (data) => {
    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // 1. Create Summary Sheet
    const summaryData = [
      ["Fuel Consumption Report", "", "", "", "", "", "", ""],
      ["", "", "", "", "", "", "", ""],
      [
        "Period:",
        `${data.Filters.startDate} to ${data.Filters.endDate}`,
        "",
        "",
        "",
        "",
        "",
        "",
      ],
      ["Total Vehicles:", data.VehicleSummaries.length, "", "", "", "", "", ""],
      [
        "Total Fuel (Ltr/kg):",
        data.OverallSummary.TotalFuel,
        "",
        "",
        "",
        "",
        "",
        "",
      ],
      [
        "Total Bill Amount (₹):",
        data.OverallSummary.TotalBillAmount,
        "",
        "",
        "",
        "",
        "",
        "",
      ],
      ["", "", "", "", "", "", "", ""],
      ["Detailed Fuel Records", "", "", "", "", "", "", ""],
      ["", "", "", "", "", "", "", ""],
    ];

    // 2. Create headers for detailed records
    const headers = [
      "No.",
      "Date",
      "Vehicle Number",
      "Driver",
      "Odometer (Km)",
      "Fuel Pump",
      "Fuel Type",
      "Fuel (Ltr/kg)",
      "Bill Amount (₹)",
      "Payment Mode",
      "KM",
      "Average",
      "Otp Verified By",
    ];
    summaryData.push(headers);

    // 3. Add all fuel records
    let recordCount = 1;
    data.VehicleSummaries.forEach((vehicle) => {
      vehicle.records.forEach((record) => {
        summaryData.push([
          recordCount++,
          formatDateToDDMMYYYY(record.Date),
          vehicle.regNumber,
          record.DriverName || "N/A",
          record.Odometer,
          record.FuelPump.toUpperCase(),
          record.FuelType.toUpperCase(),
          record.Fuel,
          record.BillAmount,
          record.PaymentType ? record.PaymentType.toUpperCase() : "",
          record.DailyKm || 0,
          record.DailyAverage || 0,
          record.ApprovedBy,
        ]);
      });
    });

    // Create worksheet
    const ws = XLSX.utils.aoa_to_sheet(summaryData);

    // Merge title cells
    ws["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 7 } }, // Title
      { s: { r: 8, c: 0 }, e: { r: 8, c: 7 } }, // Subtitle
    ];

    // Set column widths
    ws["!cols"] = [
      { wch: 8 }, // No.
      { wch: 15 }, // Date
      { wch: 18 }, // Vehicle Number
      { wch: 18 }, // Driver

      { wch: 12 }, // Fuel Type
      { wch: 12 }, // Fuel Pump
      { wch: 14 }, // Fuel
      { wch: 14 }, // Odometer
      { wch: 16 }, // Bill Amount
      { wch: 12 }, // Payment Mode
      { wch: 8 }, // Km
      { wch: 14 }, // Average
      { wch: 20 }, // Approved By
    ];

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, "Fuel Report");

    // Generate filename with timestamp
    const fileName = `Fuel_Report_${dayjs().format("YYYY-MM-DD")}.xlsx`;

    // Trigger download
    XLSX.writeFile(wb, fileName);
  };

  // Add this helper function outside your component
  function formatDateToDDMMYYYY(dateString) {
    if (!dateString) return "";

    // Extract the date part only (YYYY-MM-DD) before the 'T'
    const datePart = dateString.split("T")[0];
    const [year, month, day] = datePart.split("-");

    return `${day}-${month}-${year}`;
  }

  const handleGenerateReport = async () => {
    setIsLoading(true);

    try {
      // Prepare data for API request
      const requestData = {
        vehicles: selectedVehicles,
        fuelTypes: selectedFuelTypes,
        fuelPumps: selectedFuelPumps,
        paymentType: selectedPaymentTypes,
        startDate: startDateValue.format("YYYY-MM-DD"),
        endDate: endDateValue.format("YYYY-MM-DD"),
      };

      // Make API call
      const response = await sendRequest({
        url: "/fuelReportExcel",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: localStorage.getItem("user"),
          data: requestData,
        },
      });

      if (response && response.VehicleSummaries) {
        exportToExcel(response);
      } else {
        console.error("No valid data received from API");
        // Show error to user
      }
    } catch (error) {
      console.error("Error generating report:", error);
      // Show error to user
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="generatePdf-container"
      style={{
        zIndex: "999",
        maxWidth: window.innerWidth <= 468 ? "380px" : "",
      }}
    >
      <header>
        <span>Fuel Export Report</span>
        <CloseIcon
          style={{ cursor: "pointer" }}
          onClick={() => setIsExportButtonClicked(false)}
        />
      </header>
      <div className="generatePdf-subContainer">
        <main>
          <Backdrop
            sx={{
              color: "rgba(34, 137, 203, 255)",
              backgroundColor: "transparent",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={isLoading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>

          {/* Vehicle Selection (Multiple) */}
          <Autocomplete
            multiple
            id="vehicle-selection"
            options={vehicles}
            getOptionLabel={(vehicle) =>
              `${vehicle.regNumber} - ${vehicle.maker} ${vehicle.model}`
            }
            value={selectedVehicles}
            onChange={(event, newValue) => {
              setSelectedVehicles(newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                label="Select Vehicles*"
                placeholder="Search Vehicles"
              />
            )}
          />

          <FormControl fullWidth variant="standard" sx={{ mt: 2 }}>
            <InputLabel id="fuel-pump-label">Fuel Pump</InputLabel>
            <Select
              labelId="fuel-pump-label"
              id="fuel-pump-select"
              multiple
              value={selectedFuelPumps}
              onChange={(e) => setSelectedFuelPumps(e.target.value)}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value) => (
                    <Chip key={value} label={value} />
                  ))}
                </Box>
              )}
            >
              {fuelPumps.map((pump) => (
                <MenuItem key={pump} value={pump}>
                  {pump}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth variant="standard" sx={{ mt: 2 }}>
            <InputLabel id="fuel-type-label">Fuel Type</InputLabel>
            <Select
              labelId="fuel-type-label"
              multiple
              id="fuel-type-select"
              value={selectedFuelTypes}
              onChange={(e) => setSelectedFuelTypes(e.target.value)}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value) => (
                    <Chip key={value} label={value.toUpperCase()} />
                  ))}
                </Box>
              )}
            >
              {fuelTypes.map((type) => (
                <MenuItem key={type} value={type}>
                  {type.toUpperCase()}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth variant="standard" sx={{ mt: 2 }}>
            <InputLabel id="payment-type-label">Payment Type</InputLabel>
            <Select
              labelId="payment-type-label"
              multiple
              id="payment-type-select"
              value={selectedPaymentTypes}
              onChange={(e) => setSelectedPaymentTypes(e.target.value)}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value) => (
                    <Chip key={value} label={value} />
                  ))}
                </Box>
              )}
            >
              {paymentTypes.map((type) => (
                <MenuItem key={type} value={type}>
                  {type}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
              <DatePicker
                label="Start Date*"
                value={startDateValue}
                slotProps={{
                  textField: {
                    variant: "standard",
                    readOnly: true,
                    inputProps: { sx: { padding: "2px", fontSize: "14px" } },
                  },
                }}
                onChange={(newValue) => {
                  setStartDateValue(newValue);
                }}
              />
              <DatePicker
                label="End Date*"
                value={endDateValue}
                slotProps={{
                  textField: {
                    variant: "standard",
                    readOnly: true,
                    inputProps: { sx: { padding: "2px", fontSize: "14px" } },
                  },
                }}
                onChange={(newValue) => {
                  setEndDateValue(newValue);
                }}
              />
            </div>
          </LocalizationProvider>
        </main>
        <footer>
          <Button
            variant="contained"
            color="success"
            onClick={handleGenerateReport}
            disabled={isLoading}
            sx={{ mt: 2 }}
          >
            {isLoading ? "Generating..." : "Generate Report"}
          </Button>
        </footer>
      </div>
    </div>
  );
};

export default FuelExportModal;
